export { NoSsr as default } from '@mui/base/NoSsr';